module.exports = __webpack_public_path__ + "img/service_design_8_mob.1f69eb71.jpg";